import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  height: "24px",
  viewBox: "0 0 24 24",
  width: "24px",
  fill: "currentColor"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M0 0h24v24H0V0z",
      fill: "none"
    }, null, -1),
    _createElementVNode("path", {
      d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }